import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormatPhoneNumberPipe } from './format-phone-number.pipe';
import { FormsModule } from '@angular/forms';
import { FullyQualifyPhoneNumberPipe } from './fully-qualify-phone-number.pipe';

@NgModule({
  declarations: [FormatPhoneNumberPipe, FullyQualifyPhoneNumberPipe],
  imports: [
    CommonModule
  ],
  exports: [FormatPhoneNumberPipe, FullyQualifyPhoneNumberPipe, CommonModule, FormsModule]
})
export class PipesModule { 
  static forRoot() {
    return {
      ngModule: PipesModule,
      providers: [],
    };
  }
}
